export const GAME_IDS = [
  'peekaboo',
  'animals',
  'colors',
  'folk-songs',
  'drums',
  'puzzle',
] as const

export type GameId = (typeof GAME_IDS)[number]

export const DURATION_MINUTES = [10, 15, 20] as const
export type DurationMinutes = (typeof DURATION_MINUTES)[number]
export const DEFAULT_DURATION_MINUTES: DurationMinutes = 10

export type Unmount = () => void

export interface GameAudio {
  play(id: string, opts?: { loop?: boolean; gain?: number }): { stop: () => void }
  /** Play SFX immediately, then follow-up clips in order (voice after SFX). */
  playFeedback(leadId: string, followIds?: readonly string[]): void
}

export interface GameContext {
  audio: GameAudio
  requestHome: () => void
}

export interface GameModule {
  readonly id: GameId
  readonly titleVi: string
  /** Raw SVG markup from `src/assets/art/*.svg?raw`. */
  readonly iconSrc: string
  /** M1 games are live; M2 modules stay in the registry as dull home silhouettes. */
  readonly playable: boolean
  mount(root: HTMLElement, ctx: GameContext): Unmount
}

export function isDurationMinutes(value: number): value is DurationMinutes {
  return (DURATION_MINUTES as readonly number[]).includes(value)
}

export function isGameId(value: string): value is GameId {
  return (GAME_IDS as readonly string[]).includes(value)
}
